// frontend_react/src/services/distributorApi.js

import api, { buildCompanyScopeHeaders } from "./api";

export const searchDistributorProducts = (query, { companyUuid } = {}) =>
  api.post(
    "/distributor/search",
    {
      query_dis: query,
      status: "",
    },
    {
      headers: buildCompanyScopeHeaders(companyUuid),
    }
  );